import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPontosMonitoriaByLoja,
  getPontosMonitoriaByRegional,
} from "./services";

const initialState: any = {
  status: "",
  data: [],
};

export const actionGetPontosMonitoriaByLoja: any = createAsyncThunk(
  "ACTION_GET_PONTOS_MONITORIA",
  async (_, { getState }: any) => {
    const {
      getLojas: { lojaSelected, regionalSelected },
    } = getState();

    return getPontosMonitoriaByLoja(lojaSelected, regionalSelected, "");
  },
);

export const actionGetPontosMonitoriaByRegional: any = createAsyncThunk(
  "ACTION_GET_PONTOS_MONITORIA_REGIONAL",
  async (_, { getState }: any) => {
    const {
      regionaisAndLojas: { regionalSelected },
    } = getState();

    return getPontosMonitoriaByRegional(regionalSelected, "");
  },
);

const sliceGetPontosMonitoriaByLoja = createSlice({
  name: "GET_PONTOS",
  initialState,
  reducers: {},
  extraReducers: {
    [actionGetPontosMonitoriaByLoja.pending]: (state, p) => {
      state.status = "loading";
    },
    [actionGetPontosMonitoriaByLoja.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.data = payload;
    },
    [actionGetPontosMonitoriaByLoja.rejected]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetPontosMonitoriaByLoja.reducer;
